export type { EnsureStringArrayOptions, MaybeReadonlyArray } from '@sweetistics/contracts/utils/arrayish';
export {
  arrayFrom,
  default,
  ensureArray,
  ensureStringArray,
  optionalArrayFrom,
} from '@sweetistics/contracts/utils/arrayish';

export type NonEmptyArray<T> = readonly [T, ...T[]];

export const isNonEmptyArray = <T>(value: readonly T[]): value is NonEmptyArray<T> => value.length > 0;

export function assertNonEmptyArray<T>(
  value: readonly T[],
  message = 'Expected array to be non-empty'
): asserts value is NonEmptyArray<T> {
  if (!isNonEmptyArray(value)) {
    throw new Error(message);
  }
}

export function ensureNonEmptyArray<T>(value: readonly T[], message?: string): NonEmptyArray<T> {
  assertNonEmptyArray(value, message);
  return value;
}

export const firstOrUndefined = <T>(value: readonly T[]): T | undefined => (value.length > 0 ? value[0] : undefined);

export function firstOrThrow<T>(value: readonly T[], message = 'Expected array to contain at least one item'): T {
  assertNonEmptyArray(value, message);
  return value[0];
}
